var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.30769,13.4375c-3.64363,0 -6.61538,2.97176 -6.61538,6.61538v31.62981l-34.9375,-34.9375c-2.58413,-2.58413 -6.92548,-2.58413 -9.50962,0l-77.52404,77.73077c-2.58413,2.58413 -2.58413,6.71875 0,9.30288c2.58413,2.58413 6.71875,2.58413 9.30288,0l72.97596,-72.97596l73.18269,73.18269c1.29207,1.29207 3.04928,2.06731 4.75481,2.06731c1.70553,0 3.25601,-0.77524 4.54808,-2.06731c2.58413,-2.58413 2.58413,-6.71875 0,-9.30288l-22.94712,-22.94712v-51.68269c0,-3.64363 -2.97176,-6.61538 -6.61538,-6.61538zM86,43l-72.76923,72.76923v36.38462c0,10.95673 8.88942,19.84615 19.84615,19.84615h105.84615c10.95673,0 19.84615,-8.88942 19.84615,-19.84615v-36.38462zM72.76923,105.84615h26.46154c3.64363,0 6.61538,2.97176 6.61538,6.61538v39.69231c0,3.64363 -2.97176,6.61538 -6.61538,6.61538h-26.46154c-3.64363,0 -6.61538,-2.97176 -6.61538,-6.61538v-39.69231c0,-3.64363 2.97176,-6.61538 6.61538,-6.61538z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ed584da5de19e65804b33854b5aeb7d1.svg";
export { ForwardRef as ReactComponent };